import { yupResolver } from "@hookform/resolvers/yup";
import PillButton from "components/button/Pills";
import Input from "components/Input";
import { showToast } from "components/Toaster";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import httpClient from "services/network/httpClient";
import * as yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faEnvelope,
  faMapMarkerAlt,
  faUser
} from "@fortawesome/free-solid-svg-icons";

const schema = yup.object().shape({ // 🔹 CHANGE
  distributorName: yup.string().required("Distributor Name is required"),
  customerCode: yup.string().required("Distributor name is required"),
  email: yup.string().email("Enter a valid email").required("Email is required"),
  contactPerson: yup.string().required("Contact Person is required"),
  address: yup.string().required("Address is required"),
  phone: yup
    .string()
    .required("Mobile number is required")
    .test("is-ten-digits", "Mobile number must be exactly 10 digits", (value) => {
      if (!value) return false;
      const digits = value.replace(/\D/g, "");
      const cleaned = digits.startsWith("91") ? digits.slice(2) : digits;
      return cleaned.length === 10;
    }),
});

interface DistributorData {
  id: string;
  distributorName: string;
  email: string;
  phone: string;
  contactPerson: string;
  address: string;
}

interface EditProps {
  onClose: () => void;
  getData: () => void;
  data: DistributorData;
}

const EditDistributor = ({ data, onClose, getData }: EditProps) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { ...data },
  });

  const [phone, setPhone] = React.useState(
    data.phone ? data.phone.replace(/^\+/, "") : ""
  );
  const onsubmit = (formData: any) => {
    let formattedPhone = phone.startsWith("+") ? phone : `+${phone}`;
    const payload = {
      ...formData,
      phone: formattedPhone,
    };
    httpClient
      .put(`distributor/update`, payload)
      .then((response) => {
        console.log("Edit Distributor response");
        if (response.success === true) {
          showToast("Distributor Edited successfully", "success");
        } else {
          showToast(`${response.error.message}`, "error");
        }
      })
      .catch((error) => {
        console.log(error);
        showToast("something went wrong", "error");
      })
      .finally(() => {
        console.info("closed");
        onClose();
        getData();
      });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onsubmit)}>
        <div className="md:grid grid-cols-2 gap-6 p-2">
          <Input
            name={"distributorName"}
            label="Distributor Name"
            placeholder={"Enter Distributor Name"}
            required={true}
            alphaNumeric
            icon={<FontAwesomeIcon icon={faBuilding} className="text-gray-400" />}
          />
          <Input
            name={"customerCode"}
            label={"Distributor Code"}
            placeholder="Enter Distributor Email"
            required={true}
            icon={<FontAwesomeIcon icon={faEnvelope} className="text-gray-400" />}
          />
          <Input
            name={"email"}
            label={"Email"}
            placeholder="Enter Distributor Email"
            required={true}
            noCapitalize={true}
            icon={<FontAwesomeIcon icon={faEnvelope} className="text-gray-400" />}
          />
          <div className="flex flex-col">
            <label htmlFor="phone" className="mb-1 font-medium text-sm text-gray-900 dark:text-gray-200">Contact Number<span className="text-red-500">*</span></label>
            <div style={{ width: "200px" }}>
              <PhoneInput
                country="in"
                value={phone}
                onChange={(val) => {
                  const normalized = val.startsWith("+") ? val : `+${val}`; // 🔹 CHANGE
                  setPhone(val);
                  methods.setValue("phone", normalized, { shouldValidate: true }); // 🔹 CHANGE
                }}
                //In dark mode input field color
                inputClass="!w-full !bg-white  !text-[#374151]  !border-none  dark:!bg-gray-800  dark:!text-white [&>input]:!text-[#374151]
  dark:[&>input]:!text-white"
                buttonClass="!bg-white dark:!bg-gray-700"
                dropdownClass="
  !bg-white !text-[#374151] 
  dark:!bg-gray-800 dark:!text-white

  [&>.country:hover]:!bg-gray-100 
  [&>.country:hover]:!text-black
  dark:[&>.country:hover]:!bg-gray-700 
  dark:[&>.country:hover]:!text-white

  [&>.country.highlight]:!bg-gray-200 
  [&>.country.highlight]:!text-black
  dark:[&>.country.highlight]:!bg-gray-700 
  dark:[&>.country.highlight]:!text-white"//text color when cursor over the dropdown
                searchClass="!text-black dark:!text-black !bg-white dark:!bg-gray-700" //seach field text color
                enableSearch
                countryCodeEditable={false}

                containerStyle={{
                  width: "100%",
                  borderRadius: "0.5rem",
                  border: "1px solid #d1d5db",   // <- light mode border visible
                }}
                inputStyle={{ width: "100%" }}
                inputProps={{ name: "phone", required: true }}
              />
            </div>
            {methods.formState.errors.phone && (
              <span className="text-red-500 text-xs mt-1">
                {methods.formState.errors.phone.message as string}
              </span>
            )}
          </div>
          <Input
            name={"address"}
            label={"Address"}
            placeholder="Enter Distributor Address"
            required={true}
            icon={<FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-400" />}
          />
          <Input
            name={"contactPerson"}
            label={"Contact Person"}
            alphaNumeric
            placeholder="Enter Contact Person"
            required={true}
            icon={<FontAwesomeIcon icon={faUser} className="text-gray-400" />}
          />
        </div>
        <div className="flex flex-row items-center justify-end gap-10 mt-4">
          <PillButton type="submit" variant="secondary">
            Submit
          </PillButton>
          <PillButton type="button" variant="primary" onClick={onClose}>
            Cancel
          </PillButton>
        </div>
      </form>
    </FormProvider>
  );
};
export default EditDistributor;
